// extracted by mini-css-extract-plugin
module.exports = {"container":"Descriptions_container__2Aty6"};